import { TIMEOUT_API } from '@/shared/constants/common';
import axios from 'axios';
import { authUrl, dashUrl } from '@/legacy/config/env';
import { attachErrorReporting } from '@/shared/api-error';

export const apiPublic = axios.create({
	baseURL: dashUrl(),
	timeout: TIMEOUT_API,
});

export const authApiPublic = axios.create({
	baseURL: authUrl(),
	timeout: TIMEOUT_API,
});

// No auth headers, no refresh branch here — these instances only ever get the terminal
// reporting interceptor. Closes the observability gap on login/refresh/signup/reset flows.
attachErrorReporting(apiPublic);
attachErrorReporting(authApiPublic);

export default apiPublic;
